import { DateTime } from 'luxon';

export const ENGINEERS = [
  { value: 'inginer', text: 'Inginer', hint: 'Execută demersurile și vede echipamentele de acest tip' },
  { value: 'inginer-pc', text: 'Inginer PC', hint: 'Execută demersurile și vede echipamentele de acest tip' },
  // optional (008): every admin account gets these demersuri in Aprobare and in the notifications
  { value: 'admin', text: 'Administrator', hint: 'Execută demersurile; toți administratorii le primesc în Aprobare și în notificări' },
];
export const engineerLabel = (value) => (ENGINEERS.find((e) => e.value === value) || {}).text || value || '—';

// Romanian counts: "1 echipament", "5 echipamente", "20 de echipamente", "101 echipamente"
export function count(n, one, many) {
  const value = Number(n) || 0;
  if (value === 1) return `1 ${one}`;
  const de = value >= 20 && (value % 100 === 0 || value % 100 >= 20);
  return `${value} ${de ? 'de ' : ''}${many}`;
}

const USAGE_WORDS = {
  members: ['membru', 'membri'],
  equipment: ['echipament', 'echipamente'],
  requests: ['demers', 'demersuri'],
  children: ['subdiviziune', 'subdiviziuni'],
  catalogKinds: ['categorie în catalog', 'categorii în catalog'],
};

/** The non-zero counts of a `usage` object: [{ key, n, text, sub }] ("sub" = active items / requests in progress) */
export function usageParts(usage) {
  const u = usage || {};
  return Object.keys(USAGE_WORDS)
    .filter((key) => Number(u[key]) > 0)
    .map((key) => {
      const n = Number(u[key]);
      let sub = '';
      if (key === 'equipment' && u.activeEquipment !== undefined) sub = `${u.activeEquipment} ${Number(u.activeEquipment) === 1 ? 'activ' : 'active'}`;
      if (key === 'requests' && Number(u.openRequests) > 0) sub = `${u.openRequests} în lucru`;
      return { key, n, text: count(n, ...USAGE_WORDS[key]), label: n === 1 ? USAGE_WORDS[key][0] : USAGE_WORDS[key][1], sub };
    });
}

/** "82 de echipamente (81 active), 186 de demersuri (18 în lucru)" */
export function usageText(usage) {
  return usageParts(usage).map((p) => (p.sub ? `${p.text} (${p.sub})` : p.text)).join(', ');
}

// Same comparison the server uses for names: spaces collapsed, case and diacritics ignored
export function plain(text) {
  return String(text == null ? '' : text)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}
export const cleanText = (text) => String(text == null ? '' : text).trim().replace(/\s+/g, ' ');

export function formatDateTime(value) {
  if (!value) return '';
  const date = DateTime.fromFormat(String(value), 'yyyy-MM-dd HH:mm:ss');
  return date.isValid ? date.toFormat('dd.MM.yyyy HH:mm') : String(value);
}

/**
 * Moving a row up/down in `list` (display order) = exchanging its sort_order with the neighbour's.
 * When both have the same value the whole list is renumbered first. Returns [{ id, sort_order }] to save.
 */
export function orderPatches(list, item, dir) {
  const index = list.indexOf(item);
  const other = list[index + dir];
  if (index < 0 || !other) return [];
  if (item.sort_order !== other.sort_order && item.sort_order != null && other.sort_order != null) {
    return [
      { id: item.id, sort_order: other.sort_order },
      { id: other.id, sort_order: item.sort_order },
    ];
  }
  const next = [...list];
  next[index] = other;
  next[index + dir] = item;
  return next.map((row, i) => ({ id: row.id, sort_order: i + 1, before: row.sort_order }))
    .filter((p) => p.sort_order !== p.before)
    .map(({ id, sort_order }) => ({ id, sort_order }));
}

export const bySortOrder = (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.id - b.id;
